import React, { useEffect } from "react";

import Header from "../components/Header/Header";
import Hero from "../components/Hero/Hero";
import Projects from "../components/Projects/Projects";
import LiveProducts from "../components/LiveProducts/LiveProducts";
import Experience from "../components/Experience/Experience";
import WhatIBuild from "../components/WhatIBuild/WhatIBuild";
import Skills from "../components/Skills/Skills";
import About from "../components/About/About";
import Education from "../components/Education/Education";
import ResumeCTA from "../components/ResumeCTA/ResumeCTA";
import Contact from "../components/Contact/Contact";
import Footer from "../components/Footer/Footer";

import "../styles/Portfolio.css";

const Portfolio = () => {
  useEffect(() => {
    // Subtle Intersection Observer for smooth scroll animations
    const revealElements = document.querySelectorAll(".fade-in-section");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.05, rootMargin: "0px 0px -40px 0px" }
    );

    revealElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="portfolio-layout">
      {/* STICKY EDITORIAL HEADER */}
      <Header />

      <main className="portfolio-main">
        {/* 00 / INTRODUCTION (HERO) */}
        <section className="fade-in-section">
          <Hero />
        </section>

        {/* 01 / SELECTED WORK (ENGINEERING SYSTEMS) */}
        <section className="fade-in-section">
          <Projects />
        </section>

        {/* 02 / LIVE COMMERCIAL PRODUCTS */}
        <section className="fade-in-section">
          <LiveProducts />
        </section>

        {/* 03 / ENGINEERING EXPERIENCE */}
        <section className="fade-in-section">
          <Experience />
        </section>

        {/* 04 / CORE CAPABILITIES */}
        <section className="fade-in-section">
          <WhatIBuild />
        </section>

        {/* 05 / TECHNICAL STACK & DEPTH */}
        <section className="fade-in-section">
          <Skills />
        </section>

        {/* 06 / BACKGROUND & PHILOSOPHY */}
        <section className="fade-in-section">
          <About />
        </section>

        {/* 07 / ACADEMIC BACKGROUND & CERTIFICATIONS */}
        <section className="fade-in-section">
          <Education />
        </section>

        {/* RESUME DOWNLOAD ACTION CALLOUT */}
        <section className="fade-in-section">
          <ResumeCTA />
        </section>

        {/* 08 / DIRECT CONTACT & CHANNELS */}
        <section className="fade-in-section">
          <Contact />
        </section>
      </main>

      {/* EDITORIAL FOOTER */}
      <Footer />
    </div>
  );
};

export default Portfolio;